import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { FiHome } from "react-icons/fi";

// Function to format path names to be more readable
const formatPathName = (path) => {
  return path
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export default function Breadcrumbs() {
  const location = useLocation();

  const paths = location.pathname
    .split("/")
    .filter((path) => path !== ""); // Split the current path and filter out empty segments

  // Don't show breadcrumbs on home page
  if (paths.length === 0) {
    return null;
  }

  return (
    <Box 
      py={1} 
      px={2} 
      bg="white" 
      borderBottom="1px" 
      borderColor="gray.100"
      shadow="sm"
      position="sticky"
      top="0"
      zIndex="90"
      backdropFilter="blur(8px)"
      bgColor="rgba(255, 255, 255, 0.95)"
    >
      <Flex alignItems="center">
        <Breadcrumb
          spacing="4px"
          separator={
            <Icon 
              as={ChevronRightIcon} 
              color="gray.400" 
              boxSize={4}
            />
          }
          fontSize="sm"
          color="gray.600"
        >
          <BreadcrumbItem>
            <BreadcrumbLink
              as={RouterLink}
              to="/"
              display="flex"
              alignItems="center"
              gap={2}
              px={2}
              py={1}
              borderRadius="md"
              _hover={{ 
                bg: "blue.50", 
                color: "blue.600",
                textDecoration: "none"
              }}
              transition="all 0.2s"
              fontWeight="500"
            >
              <Icon as={FiHome} boxSize={4} />
              <Text>Dashboard</Text>
            </BreadcrumbLink>
          </BreadcrumbItem>
          
          {paths.map((path, index) => {
            let fullPath = `/${paths.slice(0, index + 1).join("/")}`;
            
            // Special handling: some parent routes don't exist, so link them to the current page
            // This keeps breadcrumbs visible and clickable without causing 404 errors
            if (fullPath === '/calendar' || fullPath === '/agraphy') {
              fullPath = location.pathname; // Link to current sub-page
            }
            
            const isCurrentPage = index === paths.length - 1;
            const displayName = formatPathName(path);

            return (
              <BreadcrumbItem
                key={`${index}-${path}`}
                isCurrentPage={isCurrentPage}
              >
                <BreadcrumbLink
                  as={isCurrentPage ? undefined : RouterLink}
                  to={isCurrentPage ? undefined : fullPath}
                  state={!isCurrentPage ? { restoreFilters: true } : undefined}
                  px={2}
                  py={1}
                  borderRadius="md"
                  fontWeight={isCurrentPage ? "600" : "500"}
                  color={isCurrentPage ? "gray.900" : "gray.600"}
                  _hover={!isCurrentPage ? { 
                    bg: "blue.50", 
                    color: "blue.600",
                    textDecoration: "none"
                  } : {}}
                  transition="all 0.2s"
                  cursor={isCurrentPage ? "default" : "pointer"}
                >
                  {displayName}
                </BreadcrumbLink>
              </BreadcrumbItem>
            );
          })}
        </Breadcrumb>
      </Flex>
    </Box>
  );
}
